import gps from "./gps";
import geocode from "./geocode";
import basemap from "./basemap";

const getInitialState = () => ({
  message: null,
  messageType: null,
  ...gps.getInitialState(),
  ...geocode.getInitialState(),
  ...basemap.getInitialState(),
});

const state = getInitialState();

const getters = {};

const mutations = {
  SET_MESSAGE(state, { message, messageType }) {
    state.message = message;
    state.messageType = messageType;
  },
  CLEAR_MESSAGE(state) {
    state.message = null;
    state.messageType = null;
  },
  RESET(state) {
    state = getInitialState();
  },
};

const actions = {};

export default {
  namespaced: true,
  state: state,
  getters: {
    ...getters,
    ...gps.getters,
    ...geocode.getters,
    ...basemap.getters,
  },
  mutations: {
    ...mutations,
    ...gps.mutations,
    ...geocode.mutations,
    ...basemap.mutations,
  },
  actions: {
    ...actions,
    ...gps.actions,
    ...geocode.actions,
    ...basemap.actions,
  },
};
